import { ShimmerButton, ShimmerThumbnail, ShimmerText,  } from "react-shimmer-effects";


const SingleGraphLoading = () => {
    return (
      <div className="min-h-[330px] rounded-lg bg-white shadow-lg p-3">
        <div>
          <div className="flex gap-8">
            <div className="grow">
              <ShimmerThumbnail height={40} rounded />
            </div>
            <ShimmerButton />
          </div>
          <ShimmerThumbnail className="mb-0" height={250} rounded />
          <ShimmerText line={1}/>
        </div>
      </div>
    )
}
  
export default SingleGraphLoading;